import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment-jalaali';
import { getAllUsers } from '../../api/users.api';

export default function UserList() {
  console.log('Rendering UserList component');
  const [users, setUsers] = useState([]);
  const [filterType, setFilterType] = useState('all');
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    console.log('Loading users...');
    try {
      const res = await getAllUsers();
      console.log('Fetched users:', res.data);
      const arr = res.data || [];
      setUsers(arr.reverse()); // جدیدترین بالا
    } catch (err) {
      console.error('Error loading users:', err);
    }
  };

  const filtered = users.filter((u) => {
    const term = search.trim();
    const matchSearch =
      !term ||
      u.name?.includes(term) ||
      u.phoneNumber?.includes(term) ||
      u.email?.includes(term);

    const matchType = filterType === 'all' || u.subscriptionType === filterType;

    return matchSearch && matchType;
  });

  const badgeClass = (type) => {
    switch (type) {
      case 'academy':
        return 'bg-blue-100 text-blue-700';
      case 'pro':
        return 'bg-emerald-100 text-emerald-700';
      case 'private':
        return 'bg-purple-100 text-purple-700';
      default:
        return 'bg-gray-200 text-gray-700';
    }
  };

  return (
    <div className="max-w-6xl mx-auto">
      {/* عنوان صفحه */}
      <h1 className="text-2xl font-bold mb-6 text-gray-800">لیست کاربران</h1>

      {/* سرچ + فیلتر */}
      <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6">
        <input
          type="text"
          placeholder="جستجو بر اساس نام، موبایل یا ایمیل..."
          className="border border-gray-300 rounded-md px-3 py-2 w-full md:max-w-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          className="border border-gray-300 rounded-md px-3 py-2 bg-white w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}>
          <option value="all">همه اشتراک‌ها</option>
          <option value="academy">آکادمی</option>
          <option value="pro">تکمیلی</option>
          <option value="private">خصوصی</option>
        </select>
      </div>

      {/* جدول */}
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr className="text-right text-gray-600">
              <th className="py-3 px-4">کاربر</th>
              <th className="py-3 px-4">موبایل</th>
              <th className="py-3 px-4">ایمیل</th>
              <th className="py-3 px-4">نوع اشتراک</th>
              <th className="py-3 px-4">تاریخ عضویت</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr>
                <td colSpan={5} className="py-6 text-center text-gray-500">
                  کاربری مطابق فیلترها پیدا نشد.
                </td>
              </tr>
            )}

            {filtered
              .filter((u) => u.status === 'active')
              .map((u) => (
                <tr
                  key={u._id}
                  className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer transition"
                  onClick={() => navigate(`/users/${u._id}`)}>
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-3">
                      {/* آواتار ساده */}
                      <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-base font-semibold text-gray-700">
                        {u.photo ? (
                          <img
                            src={u.photo}
                            alt={u.name}
                            className="w-10 h-10 rounded-full object-cover"
                          />
                        ) : (
                          u.name?.charAt(0) || '؟'
                        )}
                      </div>
                      <div>
                        <div className="font-medium text-gray-800">
                          {u.name || '—'}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td className="py-3 px-4 text-gray-700">
                    {u.phoneNumber || '—'}
                  </td>

                  <td className="py-3 px-4 text-gray-700">
                    {u.email || '—'} - {u._id}
                  </td>

                  <td className="py-3 px-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${badgeClass(
                        u.subscriptionType,
                      )}`}>
                      {u.subscriptionType || '—'}
                    </span>
                  </td>

                  <td className="py-3 px-4 text-gray-700">
                    {u.DateOfRegister
                      ? moment(u.DateOfRegister).format('jYYYY/jMM/jDD')
                      : '—'}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
